import { put, call } from "redux-saga/effects";
import { exceptionHandler } from "../pages/common/functions";
import { resourceConstants } from "../actions/constants/resourceConstant";
import ResourceService from "../services/api/resourceService";
import { getLoggedUserId } from "../services/selectors/Accounts";

function* resourceGetByFilter(request: any) {
	try {
		const result = yield call(ResourceService.resourceGetByFilter, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: resourceConstants.Resource_GetByFilter_Success,
				payload: res.data,
			});
		} else {
			yield put({
				type: resourceConstants.Resource_GetByFilter_Failure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: resourceConstants.Resource_GetByFilter_Failure,
			payload: e,
		});
	}
}

function* resourceGetActiveList(request: any) {
	try {
		const result = yield call(ResourceService.resourceGetByFilter, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: resourceConstants.Resource_GetActive_Success,
				payload: res.data,
			});
		} else {
			yield put({
				type: resourceConstants.Resource_GetActive_Failure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: resourceConstants.Resource_GetActive_Failure,
			payload: e,
		});
	}
}

function* resourceSave(request: any) {
	try {
		const result = yield call(ResourceService.resourceSave, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: resourceConstants.ResourceSaveSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: resourceConstants.ResourceSaveFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: resourceConstants.ResourceSaveFailure,
			payload: error,
		});
	}
}

function* resourceGetDetail(request: any) {
	try {
		const result = yield call(ResourceService.resourceGetDetail, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: resourceConstants.ResourceDetailSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: resourceConstants.ResourceDetailFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: resourceConstants.ResourceDetailFailure,
			payload: error,
		});
	}
}

function* resourceDelete(request: any) {
	try {
		const result = yield call(ResourceService.resourceDelete, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: resourceConstants.ResourceDeleteSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: resourceConstants.ResourceDeleteFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: resourceConstants.ResourceDeleteFailure,
			payload: error,
		});
	}
}

function* resourceUpdateStatus(request: any) {
	try {
		const { id, isActive } = request.input;

		const result = yield call(ResourceService.resourceUpdateStatus, {
			adminUserId: parseInt(getLoggedUserId()),
			productId: id,
			isActive: isActive,
		});
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: resourceConstants.ResourceStatusUpdateSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: resourceConstants.ResourceStatusUpdateFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: resourceConstants.ResourceStatusUpdateFailure,
			payload: error,
		});
	}
}

export const resourceSaga = {
	resourceGetByFilter,
	resourceGetActiveList,
	resourceSave,
	resourceGetDetail,
	resourceDelete,
	resourceUpdateStatus
};
